import React from "react";
import { Helmet } from "react-helmet";

import ContactForm from "../components/ContactForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
  faClock,
} from "@fortawesome/free-solid-svg-icons";

export const İletisim= () => {
  return (
    <div className="contact-page">
    <Helmet>
  <title>İletişim | Ali Arda Gül Hukuk Bürosu</title>
  
  {/* SEO Açıklaması */}
  <meta
    name="description"
    content="Hukuki sorunlarınız için bizimle iletişime geçin. Çeşitli hukuk alanlarında danışmanlık ve temsil hizmetleri sunuyoruz."
  />

  {/* Anahtar Kelimeler */}
  <meta
    name="keywords"
    content="avukat, Ankara, hukuki hizmetler, aile hukuku, ticaret hukuku, ceza hukuku, Ali Arda Gül"
  />

  {/* Yazar Adı */}
  <meta name="author" content="Ali Arda Gül" />
</Helmet>

      <section>
        <h6 className="guide-text ms-3 mt-4">İLETİŞİM</h6>
        {/* iletişim bilgileri============ */}
        <div className="container-lg bg-light my-5 shadow">
          <div className="contact-info text-center py-5">
            <div className="row no-gutters">
              <div className="col-lg-3 col-md-6 col-12 border-end border-1">
                <div className="contact-inner">
                  <div className="info-i">
                    <span>
                      <FontAwesomeIcon
                        icon={faLocationDot}
                        size="2x"
                        className="law-icon pb-3"
                      />
                    </span>
                  </div>
                  <h5>Adres </h5>
                  <p>Ayrancı Mah. Kuveyt Caddesi. Hayır:28/5
                  Çankaya Ankara</p> 
                   
              
                  
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-12 border-end border-1">
                <div className="contact-inner">
                  <div className="info-i">
                    <span>
                      <FontAwesomeIcon
                        icon={faClock}
                        size="2x"
                        className="law-icon pb-3"
                      />
                    </span>
                  </div>
                  <h5>Çalışma Saatleri:</h5>
                  <p>Pazartesi – Cumartesi: 09.00 – 18.00</p>
                 
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-12 border-end border-1">
                <div className="contact-inner">
                  <div className="info-i">
                    <span>
                      <FontAwesomeIcon
                        icon={faEnvelope}
                        size="2x"
                        className="law-icon pb-3"
                      />
                    </span>
                  </div>
                  <h5>E-Posta:</h5>
                  <p>av.aliardagul@gmail.com</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                <div className="contact-inner">
                  <div className="info-i">
                    <span>
                      <FontAwesomeIcon
                        icon={faPhone}
                        size="2x"
                        className="law-icon pb-3"
                      />
                    </span>
                  </div>
                  <h5>Telefon:</h5>
                  <p> +90 543 882 20 92</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* iletişim formu ve metin============ */}
        <div className="container-lg">
          <div className="row g-5">
            <div className="col-sm-6 order-sm-first ">
              <div className="contact-text d-flex flex-column ">
                <h4 className="lh-base text-center pb-4">
                Hukuki Destek Talebiniz İçin İletişime Geçin!
                </h4>
                <p>
                Hukuki konularınızda size en iyi desteği sağlamak için buradayız. Size etkili ve profesyonel çözümler sunabilmek adına her talebinizi dikkatle değerlendireceğiz.
                </p>
                <p>
                Formu doldurarak bize ileteceğiniz mesajlar, anlık olarak tarafımızca incelenecektir. 
                </p>
                <p>
                Talebinizi aldıktan sonra, gerekli detayları toplamak ve size en uygun çözümleri sunmak için kısa süre içinde geri dönüş yapacağız.
                </p>
              </div>
            </div>
            <div className="col-sm-6 ">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default İletisim;
